import {useState, useEffect, useRef, useCallback} from "react";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {inject, observer} from "mobx-react";
import './settings.css'
import VehicleTypeManagementGrid from "./VehicleTypeManagementGrid";
import {Layout, LayoutChild} from "../../../../palette/Palette";
import Alerts from "../../../../palette/Alerts";
import {db} from "../../../../firebase/Firebase";
import VehicleTypeManagementForm from "./VehicleTypeManagementForm";
import VehicleTypeManagementEditForm from "./VehicleTypeManagementEditForm";
import {Animated} from "react-animated-css";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function VehicleTypeManagement(props) {

    const {DataStore, ControlStore} = props
    const {companyName, idCompany, finished} = DataStore

    const [load, setLoad] = useState(false)
    const [textLoad] = useState('Cargando...')
    const [dataSource, setDataSource] = useState([])
    const [trigger, setTrigger] = useState(false)
    const [visibleGrid, setVisibleGrid] = useState(true)
    const [visibleForm, setVisibleForm] = useState(false)
    const [edit, setEdit] = useState(false)
    const [dataEdit, setDataEdit] = useState(null)

    const isMounted = useMountedState()

    useEffect(() => {
        const GetTypesVehicles = async () => {
            const newArray = []
            let ID = 0
            await db.collection(companyName).doc(idCompany).collection('TypesVehicles')
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if (doc.exists) {
                            ID = ID + 1
                            const obj = {...doc.data(), ID: ID, docId: doc.id}
                            newArray.push(obj)
                        } else {
                            setDataSource([])
                            setLoad(true)
                        }
                    });
                    newArray.length > 0 && ControlStore.getTypesVehiclesStatus(true)
                    setDataSource(newArray)
                    setLoad(true)
                })
        }

        if (isMounted()) {
            GetTypesVehicles().catch(() => {
            })
        }
    }, [companyName, idCompany, isMounted, trigger])

    return (
        <>
            {!finished &&
            <LayoutChild percent={95} margin="auto" top={25}>
                <Alerts severity={'warning'}
                        body={'¡No se han terminado de configurar los datos de la empresa!'}/>
            </LayoutChild>}

            <VerticalSpace space={30}/>
            {(visibleGrid && finished) &&
            <div className="grid-container">
                <HeaderPage icon={'fas fa-car'} text={'Tipos de vehículos'} load={load}
                            textLoad={textLoad}/>


                <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleGrid}>
                    <VehicleTypeManagementGrid dataSource={dataSource} companyName={companyName} setEdit={setEdit}
                                               setVisibleForm={setVisibleForm} setVisibleGrid={setVisibleGrid}
                                               setDataEdit={setDataEdit} DataStore={DataStore}
                                               setTrigger={setTrigger} trigger={trigger}/>
                </Animated>
            </div>}
            {visibleForm &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleForm}>
                <VehicleTypeManagementForm setVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger}
                                           DataStore={DataStore} setVisibleGrid={setVisibleGrid}/>
            </Animated>}

            {(edit && dataEdit) &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={edit}>
                <VehicleTypeManagementEditForm setTrigger={setTrigger} trigger={trigger} DataStore={DataStore}
                                               dataEdit={dataEdit} setVisibleGrid={setVisibleGrid}
                                               setDataEdit={setDataEdit} setEdit={setEdit}/>
            </Animated>}
        </>

    )
}

export default inject('DataStore', 'ControlStore')(observer(VehicleTypeManagement));